import { render, staticRenderFns } from "./appNotice.vue?vue&type=template&id=171dbfb6&scoped=true"
import script from "./appNotice.vue?vue&type=script&lang=js"
export * from "./appNotice.vue?vue&type=script&lang=js"
import style0 from "./appNotice.vue?vue&type=style&index=0&id=171dbfb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171dbfb6",
  null
  
)

export default component.exports